/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { ConfirmationModal } from '../index';
import { EditAttributes } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

export const SaveNewEmpModal = (props) => {
  return (
    <>
      <ConfirmationModal
        open={props.open}
        onClose={props.onClose}
        primaryClickHandler={() => {
          props.handleEdit();
          props.onClose();
        }}
        secondaryClickHandler={props.onClose}
        title={
          <Box display="flex" alignItems="center" gap={1}>
            <EditAttributes sx={{ fontSize: 30 }} />
            <Typography variant="h6" fontWeight={600} color={'#84D8C5'}>
              Save Changes
            </Typography>
          </Box>
        }
        desc={
          <Box>
            <Typography variant="body1" sx={{ mt: 3, mb: 2 }}>
              Are you sure the details are accurate for the employee:
            </Typography>

            <Typography
              variant="h6"
              component="div" // <- prevents it from being inside <p>
              fontWeight={700}
              sx={{ mb: 5 }}
              color={'primary.main'}
            >
              {props.savedName}
            </Typography>

            <Typography variant="body2" color="text.secondary">
              This will create an edit request for your personal information.
            </Typography>
          </Box>
        }
        primaryBtnName={'Confirm'}
        secondaryBtnName={'Cancel'}
      />
    </>
  );
};
